import logo from './logo.svg';
import './App.css';
import M from './components/Menu'
import Profile from './components/Professional'
import About from './components/About'
import Resume from './components/Resume';

import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

function App() {
  return ( 
    <BrowserRouter>
    <Routes>
      <Route path='/' element={<M />}>
      <Route index element={<About />} />
        <Route path="resume" element={<Resume />} />
        <Route path="about" element={<About />} />
        <Route path="profile" element={<Profile />} />
        <Route path="*" element={<About />} />
      </Route>
      
    </Routes>
  </BrowserRouter>
  );
}

export default App;
